import type { ComponentContentSchema } from '@vibesites/runtime';
import {
  useBlockSlot,
  SectionContextProvider,
  EditableToken,
} from '@vibesites/runtime/react';

// ============================================================================
// Component
// ============================================================================

export function ScheduleTourForm() {
  const prefix = 'scheduletourform';
  const formBlockPath = `${prefix}.form_block`;

  const formSlot = useBlockSlot(formBlockPath, {
    defaultValue: 'multihub-tour-scheduler',
  });

  return (
    <>
      {/* Plain white section + centered scheduler */}
      <div className="stf-parallax-section">
        {/* Centered form */}
        <div className="stf-parallax-content">
          <div className="stf-form-wrap">
            <EditableToken path={formBlockPath} as="div">
              {formSlot ? (
                <SectionContextProvider sectionId={formSlot.sectionId}>
                  <formSlot.BlockComponent sectionId={formSlot.sectionId} />
                </SectionContextProvider>
              ) : (
                <div className="stf-form-empty-card">
                  <p className="stf-form-empty">No form block selected</p>
                </div>
              )}
            </EditableToken>
          </div>
        </div>
      </div>

      {/* Schema-lint anchor — static path so the linter can match the block token.
          The live EditableToken above uses a dynamic path built from prefix. */}
      <EditableToken path="scheduletourform.form_block" as="div" className="hidden" style={{ display: 'none' }}>{''}</EditableToken>

      <style>{`
        /* ── Section (plain white background) ── */
        .stf-parallax-section {
          position: relative;
          overflow: hidden;
          min-height: 0;
          padding: 1.25rem 1.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background: white;
        }
        @media (min-width: 768px) {
          .stf-parallax-section {
            min-height: 520px;
            padding: 6rem 2rem;
          }
        }

        .stf-parallax-content {
          position: relative;
          z-index: 10;
          width: 100%;
          display: flex;
          justify-content: center;
        }

        .stf-form-wrap {
          width: 100%;
          max-width: 640px;
          border-radius: var(--vibe-radius-lg, 12px);
          overflow: hidden;
          box-shadow: 0 8px 40px rgba(0, 0, 0, 0.25);
        }
        /* Uppercase the block's wizard heading */
        .stf-form-wrap h3 {
          text-transform: uppercase;
        }

        .stf-form-empty-card {
          background: white;
          border-radius: var(--vibe-radius-lg, 12px);
          padding: 2rem;
        }
        .stf-form-empty {
          font-family: var(--vibe-font-body);
          font-size: 0.95rem;
          color: var(--vibe-color-text-muted);
          text-align: center;
          margin: 0;
          padding: 2rem 0;
        }
      `}</style>
    </>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'ScheduleTourForm',
  displayName: 'Schedule A Tour Form',
  tokens: {
    'scheduletourform.form_block': {
      label: 'Form Block',
      type: 'block',
      defaultValue: 'multihub-tour-scheduler',
      acceptedBlockCategories: ['Forms'],
    },
  },
};

(ScheduleTourForm as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default ScheduleTourForm;
